import { CombinedGraphQLErrors } from '@apollo/client/errors'
import { ErrorLink } from '@apollo/client/link/error'
import type { ApolloHandlers } from '@dolpheen/apollo/handlers'
import { isJwtError } from '@sections/auth/errors'

export const createAuthErrorLink = (getHandlers: () => ApolloHandlers): ErrorLink =>
  new ErrorLink(({ error }) => {
    if (CombinedGraphQLErrors.is(error) && error.errors.some(isJwtError)) {
      getHandlers().onAuthError()
    }
  })
